export default "__VITE_ASSET__efc08fa5__"